import Vue from 'vue'
import store from '../store'
import templatesDefinitions from '../store/templates'

export default class TemplateDefinitionsService {
  constructor ($keycloak, $store) {
    this.$keycloak = $keycloak
    this.$store = $store || store
  }

  getAllowedRules () {
    const selectedAccount = this.$store && this.$store.getters && this.$store.getters.selectedAccount
    const templateLibraryPolicies = selectedAccount &&
      selectedAccount.policies &&
      selectedAccount.policies.templateLibrary &&
      selectedAccount.policies.templateLibrary.allow
    if (templateLibraryPolicies && templateLibraryPolicies.length > 0) {
      return templateLibraryPolicies.filter(p => !p.startsWith('library:'))
    }
    let roles = this.$keycloak && this.$keycloak.resourceAccess && this.$keycloak.resourceAccess['webcg-studio'] &&
      this.$keycloak.resourceAccess['webcg-studio'].roles
    roles = roles && roles.length > 0 ? roles : ((Vue.prototype.$env && Vue.prototype.$env.DEFAULT_ROLES) || [])
    if (typeof roles === 'string') {
      try {
        roles = JSON.parse(roles)
      } catch (e) {}
    }
    return roles.filter(p => !p.startsWith('library:'))
  }

  getTemplateDefinitions () {
    const allowedRules = this.getAllowedRules()
    console.log('[template-definitions] Allowed rules', allowedRules)
    const templates = templatesDefinitions.filter(td => {
      const groups = Array.isArray(td.groups) ? td.groups : (td.groups ? [td.groups] : [])
      return groups.length === 0 || allowedRules.indexOf('*') >= 0 || groups.some(x => allowedRules.indexOf(x) >= 0)
    })
    console.log('[template-definitions] Allowed templates', templates)
    return templates
  }

  findTemplateDefinition (componentType) {
    return this.getTemplateDefinitions().find(p => p.componentType === componentType)
  }
}



// WEBPACK FOOTER //
// ./src/services/template-definitions.service.js